import React from "react";
import { Container } from "../../../../components";
import Verification from "./Verification";
import { PHONE_NUMBER_LEN } from "../../../../../../constants";
import { VerificationDeliveryMethod } from "../../../consts";

type Props = {
    isLoadingPhoneNumberCheck?: boolean;
    selectedPhoneNumber: string;
    sendCode: (number: string, method: VerificationDeliveryMethod) => Promise<void>;
    validatePhoneNumber?: boolean;
    verifyCode: (code: string, number: string) => Promise<void>;
};

const RenderVerification: React.FC<Props> = ({
    selectedPhoneNumber,
    isLoadingPhoneNumberCheck,
    sendCode,
    verifyCode,
    validatePhoneNumber = true,
}) => {
    const onlyDigits = (selectedPhoneNumber || "").replace(/\s/g, "");
    const validPhoneNumber = onlyDigits.length === PHONE_NUMBER_LEN || !validatePhoneNumber;
    const shouldShowVerification = !isLoadingPhoneNumberCheck && validPhoneNumber;

    if (!shouldShowVerification) return <></>;

    return (
        <Container className="transfer-ownership-page__section" size="medium" whiteBg data-di-mask>
            <Verification number={onlyDigits} sendCode={sendCode} verifyCode={verifyCode} />
        </Container>
    );
};

export default RenderVerification;
